<template>
  <v-row v-if="$store.state.auth.checkAccess({key: 'loyalty', value: true})">
    <v-col :cols="12">
      <material-card class="mt-0" color="green">
        <template v-slot:header>

          <v-row
            class="px-3 mx-0"
          >
            <h4
              class="title font-weight-light mb-0"
              v-html="'Loyalty: <b>' + roundedLoyalty + ' points</b>'"
            />
            <v-spacer />
            <!--          :title="'Loyalty: <b>' + roundedLoyalty + ' points</b>'"-->
            <default-history
              class="float-right"
              type="loyalty_update"
              handler="default"
              icon="history"
              color="white"
              width="550"
              title="Loyalty History"
            />
          </v-row>
        </template>

        <v-row :class="{'col-10': $vuetify.breakpoint.name != 'xs' && $vuetify.breakpoint.name != 'sm', 'mx-auto': true, 'pt-0': true, 'pb-0': true}" v-if="$store.state.auth.checkAccess({key: 'loyalty_update', value: true})">
          <v-btn
            class="col-4 mt-3"
            color="blue light"
            small
            @click="update('decrease')"
            style="min-width: 80px;"
            :disabled="activeAccount.loading"
            :loading="activeAccount.loading"
          >
            Decrease
          </v-btn>
          <v-text-field
            class="col-4 pb-0"
            label="Amount"
            v-model="loyalty"
            style="min-width: 70px;"
            hide-details
          ></v-text-field>
          <v-btn
            class="col-4 mt-3"
            color="info"
            small
            style="min-width: 80px;"
            :disabled="activeAccount.loading"
            :loading="activeAccount.loading"
            @click="update('increase')"
          >
            Increase
          </v-btn>
        </v-row>
      </material-card>
    </v-col>
  </v-row>
</template>

<style>
  .custom_label > label div {
    vertical-align: super;
    display: inline-block;
    cursor: pointer;
    user-select: none;
    line-height: 24px;
  }
</style>

<script>
  import { API } from '@/utils/api'
  import { mapGetters } from 'vuex'
  import { round } from 'lodash'

  export default {
    props: [],

    components: {
      DefaultHistory: () => import('@/components/helper/DefaultHistory'),
    },

    data: () => ({
      loyalty: 0,
      loading: false
    }),

    computed: {
      ...mapGetters({ activeAccount: 'account/active' }),
      roundedLoyalty () {
        return round(this.activeAccount.account.loyalty, 2)
      }
    },

    mounted () {
    },

    methods: {
      update (type) {
        this.activeAccount.loading = true

        API.call('/$v/account/loyalty/update.json', {
          login: this.activeAccount.account.login,
          account_id: this.activeAccount.account.account_id,
          type,
          amount: this.loyalty
        }, this.activeAccount.account).then(resp => {
          this.activeAccount.account.loyalty = resp.data.loyalty
          this.loyalty = 0
          return resp.data
        }).then(r => {
          this.$notification.show = true
          this.$notification.message = 'Loyalty ' + type + 'd'
          this.$notification.type = 'success'
        }).catch(e => {
          return e
        }).finally(() => {
          this.activeAccount.loading = false
        })
      }
    },

  }
</script>
